// extracted by mini-css-extract-plugin
export var tabContainer = "squareTabs-module--tabContainer--H6Nwy";
export var active = "squareTabs-module--active--cgndJ";
export var tabContentContainer = "squareTabs-module--tabContentContainer--8CNIN";
export var fadeIn = "squareTabs-module--fadeIn--OtuqA";
export var tabContent = "squareTabs-module--tabContent--3cNNF";
export var slideIn = "squareTabs-module--slideIn--o73By";